export const APP_CONSTANTS = {
  APP_VERSION: "2.1.3",
  index: "/",
  FEATURE_HIDE_COMPANY:
    process.env.REACT_APP_BRANCH === "prod"
      ? [21]
      : process.env.REACT_APP_BRANCH === "alpha"
      ? [2, 21] // Adjusted for alpha
      : [1, 21],
  ROLES: {
    ADMIN: "ADMIN",
    SALES_REP: "SALES_REP",
  },
  base_url:
    process.env.REACT_APP_BRANCH === "prod"
      ? process.env.REACT_APP_PROD_BASE_URL
      : process.env.REACT_APP_BRANCH === "alpha"
      ? process.env.REACT_APP_ALPHA_BASE_URL // Added alpha base URL
      : process.env.REACT_APP_BETA_BASE_URL,
  gql_connection:
    process.env.REACT_APP_BRANCH === "prod"
      ? "https://cerebro-public-prod-f43i3yczga-uc.a.run.app/graaaaphql/"
      : process.env.REACT_APP_BRANCH === "alpha"
      ? "https://cerebro-public-beta-f43i3yczga-uc.a.run.app/graaaaphql/"
      : "https://cerebro-public-beta-f43i3yczga-uc.a.run.app/graaaaphql/",
  gql_connection_wss:
    process.env.REACT_APP_BRANCH === "prod"
      ? "wss://cerebro-public-prod-f43i3yczga-uc.a.run.app/graaaaphql-sub/jhf23iune9f426ojnf6s6k8jdf/"
      : process.env.REACT_APP_BRANCH === "alpha"
      ? "wss://cerebro-public-beta-f43i3yczga-uc.a.run.app/graaaaphql-sub/jhf23iune9f426ojnf6s6k8jdf/"
      : "wss://cerebro-public-beta-f43i3yczga-uc.a.run.app/graaaaphql-sub/jhf23iune9f426ojnf6s6k8jdf/",
  marketing_agencies: "Marketing Services",
  MICROSOFT_CLIENT_ID:
    process.env.REACT_APP_BRANCH === "prod"
      ? "a27d32ee-fa11-4599-a647-6a5dfae03dee"
      : process.env.REACT_APP_BRANCH === "alpha"
      ? "271bc082-0701-454e-8a72-6341a9739236-alpha" // Added alpha client ID
      : "271bc082-0701-454e-8a72-6341a9739236",
  SENTRY: "https://15ed2a3fb66f4b50a434edb0dd926937@o514629.ingest.sentry.io/5860987",
};

export const FEATURE_CONSTANTS = {
  FCBE: "FCBE",
  FCSI: "FCSI",
  FCEI: "FCEI",
  FCIE: "FCIE",
  FCAISDR: "FCAISDR",
  FCAE: "FCAE",
  FCUP: "FCUP",
  FCCEM: "FCCEM",
  FCCP: "FCCP",
  FCSSR: "FCSSR",
  FCECPM: "FCECPM",
  FCIOGW: "FCIOGW",
  FCETS: "FCETS",
  FCTPMM: "FCTPMM",
  FCDP: "FCDP",
  FCPV: "FCPV",
};
